import { useSyncExternalStore } from "react";
import { _ } from "i18n";
import type { ColumnConfig } from "../../types";
import { DISCOVER_GAMES_BULK_SELECT_KEY, DISCOVER_GAMES_COL_WIDTH_BULK_SELECT } from "../constants";
import type { GameRow } from "../types";
import { discoverGameRowId } from "../rowHelpers";
import { useDiscoverGamesBulkSelectStore } from "./store";
import { DiscoverGamesBulkSelectAllHeader } from "./BulkSelect";

function useDiscoverGameRowBulkSelected(id: number | null): boolean {
	const store = useDiscoverGamesBulkSelectStore();
	return useSyncExternalStore(
		store.subscribe,
		() => (id === null ? false : store.isSelected(id)),
		() => false,
	);
}

function DiscoverGamesBulkSelectCell({ row }: { row: GameRow }) {
	const id = discoverGameRowId(row);
	const store = useDiscoverGamesBulkSelectStore();
	const checked = useDiscoverGameRowBulkSelected(id);
	if (id === null) {
		return null;
	}
	return (
		<div className="discoverGamesTableV3-bulkSelectCell" onClick={(e) => e.stopPropagation()}>
			<input
				type="checkbox"
				checked={checked}
				onChange={() => store.toggle(id)}
				aria-label={_("discover.gamesTable.aria.bulkSelectRow")}
			/>
		</div>
	);
}

/** Column definition for bulk row selection checkboxes. */
export function bulkSelectColumn(): ColumnConfig<GameRow> {
	return {
		key: DISCOVER_GAMES_BULK_SELECT_KEY,
		label: "",
		sortable: false,
		minWidth: DISCOVER_GAMES_COL_WIDTH_BULK_SELECT.min,
		maxWidth: DISCOVER_GAMES_COL_WIDTH_BULK_SELECT.max,
		sticky: true,
		header: (ctx) => <DiscoverGamesBulkSelectAllHeader pageRowIds={ctx.pageRowIds} />,
		cell: (_, row) => <DiscoverGamesBulkSelectCell row={row} />,
		group: _("discover.gamesTable.group.basic"),
		defaultVisible: true,
		requiredFields: ["id"],
	};
}
